import React from "react";

const ErrorPage = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center text-center vh-100">
      <h4>Eroare 404</h4>
      <p>Pagina nu a putut fi găsită.</p>
    </div>
  );
};

export default ErrorPage;
